import React, {Component} from 'react';
import '../App.css';
import $ from "jquery";

class ConfigItemsDashboardModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            config: [],
        }
    }

    componentDidMount(){
    }

    toggleCheckBox = index => {
        const  { toggleChangeConfig  } = this.props;
        toggleChangeConfig(index);
    }

    renderConfigHeaderSelector = () => {
        let config = [];
        const {dataConfig} = this.props;

        config = dataConfig.map((header, index) => {
            return (
                <tr key={index}>
                    <td style={{maxWidth: 200}}>{header.title}</td>
                    <td style={{textAlign: "right"}}><input type="checkbox" checked={header.value} style={{height: 20, width: 20}} onChange={() => this.toggleCheckBox(index)}/></td>
                </tr>
            )
        })
        return config;
    }

    saveConfig = () => {
        const {onAcceptConfig} = this.props;
        onAcceptConfig()
    };

    render() {
        const {onCancelConfig} = this.props;
        return (
            <div className="modal fade" id="configItemsDashboardModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">Mostrar Elementos del Dashboard y menu</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCancelConfig}>
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{height: 550, maxHeight: 550}}>
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <strong>Seleccione los elementos que quiera visualizar:</strong>
                                        <div style={{height: 400, overflow: 'auto'}}>
                                            <table className="table" style={{marginBottom: 0}}>
                                                <tbody>
                                                {this.renderConfigHeaderSelector()}
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar" data-dismiss="modal" onClick={onCancelConfig}>Cerrar</button>
                            <button type="button" className="btn botonCorrect" onClick={this.saveConfig}>Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfigItemsDashboardModal;
